const exitPopupTheme = `<div class="ExitPopup__content__wrap">
<div class="ExitPopup__text">
<div class="ExitPopup__heading">
  <div class="ExitPopup__heading__sup">Doing STEM tasks becomes easier!</div>
  <div class="ExitPopup__heading__text">Get <span>20% off</span> your first order to solve your problem with our help.</div>
</div>
<a data-banner-btn href="/dashboard/orders/create/?couponCode=SAVE20NOW&orderServiceTypeId=46" data-ga-label="claim_discount" class="hero__cta-btn btn btn--circle"><span class="btn__inner"><span>Claim my</span><span>discount</span></span></a></div>
<div class="ExitPopup__img"><img src="/images/exit-popup/img_popup.svg" alt=""></div>
</div>`;

export default exitPopupTheme;
